

import { Time } from '@angular/common';
import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import * as TimeSpan from 'timespan';
import { PatientRegistration } from './patient-registration';
import { Department, DepartmentData } from '../masters/department';
import { Physician } from '../masters/physician-mst';
import { Visit } from '../ehr/visit';
import { PatientAppointment } from './patient-appointment';

export interface AppointmentStatusDetailParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface AppointmentStatusDetail {
    id?: any;
    tenantId: any;
    branchId: any;
    visitId: number;
    regId: any;
    status: string;
    updatedBy: string;
    updatedOn: Date;
    patientRegistrationMst?: PatientRegistration;
    visit?: Visit;
    patientAppointment?: PatientAppointment;

    parameters?: AppointmentStatusDetailParameter[];
   
}

export const AppointmentStatus = {
    DELETED: 'deleted',
    CHECKEDIN: 'Checked-in',
    BOOKED: 'booked',
    ARRIVED : 'arrived', 
    FULFILLED: 'fulfilled',
    CANCELLED : 'cancelled', 
    NOSHOW: 'noshow'
};
  
export abstract class AppointmentStatusData {
    
    
    abstract getById(url: string): Observable<any>;
    abstract create(url: string, data: AppointmentStatusDetail): Observable<AppointmentStatusDetail>;
   
}